import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

import { ChatbotAxios } from "../../axios/chatbot/chatbot.axios";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { Chatbot } from "../../model/chatbot/Chatbot";
import { DeleteChatbotDto } from "../../model/chatbot/dto/DeleteChatbotDto";
import { CreateChatbotDto } from "../../model/chatbot/dto/CreateChatbotDto";
import { UpdateChatbotDto } from "../../model/chatbot/dto/UpdateChatbotDto";

interface ChatbotReducer {
  bots: Chatbot[];
}

const initialState = Object.freeze<ChatbotReducer>({
  bots: [],
});

const createChatbot = AtiraThunk<void, CreateChatbotDto>(
  `/chatbot/create`,
  ChatbotAxios.createChatbot,
);

const getChatbots = AtiraThunk<Chatbot[], GenericWithUserId>(
  `/chatbot/get`,
  ChatbotAxios.getChatbots,
);

const deleteChatbot = AtiraThunk<void, DeleteChatbotDto>(
  `/chatbot/delete`,
  ChatbotAxios.deleteChatbot,
);

const updateChatbot = AtiraThunk<void, UpdateChatbotDto>(
  `/chatbot/update`,
  ChatbotAxios.updateChatbot,
);

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getChatbots.fulfilled, (state, action) => {
      // @ts-ignore
      state.bots = action.payload as Chatbot[];
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), () => {
      return initialState;
    });
  },
});

export const chatbotActions = {
  createChatbot,
  getChatbots,
  deleteChatbot,
  updateChatbot,
  ...chatbotSlice.actions,
};

export default chatbotSlice.reducer;
